import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Media from 'react-media';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import Menu from '../../../../components/LazyWidgets/Menu';
import ReportError from '../ReportError';
import { subUnitHighlightsComponent, performanceByLearningObjectiveComponent } from './qqComponents';
import { REPORT_TYPES } from '../../../actions/constants';

import ReportBreadcrumbs from '../../../../components/ReportBreadcrumbs/ReportBreadcrumbs';
import PerformanceByAssignmentComponent from './qqComponents/performanceByAssignmentComponent';
import PerformanceByStudentComponent from './qqComponents/performanceByStudentComponent';
import style from './QuantQual.module.css';
import {
  loadSubunitReport as loadSubunitReportAction,
  updateSubunitReport as updateSubunitReportAction,
  sendAnalyticsEvent,
} from '../../../actions/reports';
import ExternalFrameworkCard from '../../../../components/ExternalFrameworkCard';
import { getConfigObject } from '../../../util/config';

class QQReport extends Component {
  static propTypes = {
    onTabChange: PropTypes.func,
    reportType: PropTypes.string,
    subUnitId: PropTypes.string,
    unit: PropTypes.object,
    course: PropTypes.object,
    subunits: PropTypes.array,
    loadSubunitReport: PropTypes.func,
    sendAnalyticsEvent: PropTypes.func,
    updateSubunitReport: PropTypes.func,
    subunitReport: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.any,
    activeSubunit: PropTypes.object,
  }

  static getDerivedStateFromProps(newProps, prevState) {
    const { subUnitId } = prevState;
    const newId = newProps.subUnitId || null;
    if (newId !== subUnitId) {
      return { subUnitId: newId };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      subUnitId: this.props.subUnitId,
    };
    this.handleSubmoduleUpdate = this.handleSubmoduleUpdate.bind(this);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const { course: { id }, loadSubunitReport, subUnitId } = this.props;
    loadSubunitReport(id, subUnitId);
  }

  componentDidUpdate(prevProps, prevState) {
    this.adjustDropDowns();
    if (prevState.subUnitId !== this.state.subUnitId) {
      this.props.updateSubunitReport(this.state.subUnitId);
    }
  }

  adjustDropDowns() {
    if (this.containerRef.current) {
      const dropDowns = this.containerRef.current.getElementsByTagName('select');
      for (const dropDown of dropDowns) {
        const fakeWidth = this.calculateFakeWidth(dropDown.options[dropDown.selectedIndex].textContent);
        if (fakeWidth > dropDown.offsetWidth + 3) {
          dropDown.parentElement.classList.add(style.ellipsis);
        }
      }
    }
  }

  calculateFakeWidth(text) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    tempDiv.style.fontSize = '17px';
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = -1000;
    tempDiv.style.top = -1000;
    tempDiv.style['white-space'] = 'nowrap';
    tempDiv.style.lineHeight = '32px';
    tempDiv.innerHTML = text;
    const width = tempDiv.clientWidth;
    document.body.removeChild(tempDiv);
    return width;
  }

  async handleSubmoduleUpdate(value) {
    const { subunits, updateSubunitReport, onTabChange } = this.props;
    const newActiveSubunit = subunits[value];
    await updateSubunitReport(newActiveSubunit.id);
    onTabChange(`reports/type/subunit/${newActiveSubunit.id}`);
  }

  render() {
    if (this.props.loading) return <Spinner className={style.qqReportSpinner} />;
    const {
      error,
      subunitReport: {
        error: errorReport,
      },
    } = this.props;

    if (error || errorReport) return <ReportError />;

    const {
      onTabChange,
      subunits,
      unit,
      subunitReport: {
        hasStudents,
        subunitHighlights,
        performanceByExternalFrameworks,
        performanceByLearningObjective,
        performanceByAssignment,
        performanceByStudent,
      },
      activeSubunit,
      course,
      reportType,
    } = this.props;

    const breadcrumbItems = [
      { text: 'Overview', targetUrl: 'reports' },
      { text: unit.name || 'Unit Report', targetUrl: `reports/type/unit/${unit.id}` },
      { text: activeSubunit.name || 'Subunit Report' }];

    const modalContent = (
      <div>
        <p><b>Assignments Completed</b> represents the number of assignments the individual student has completed out of the total number of resources assigned to the student in this Subunit.<br /></p>
        <p><b>Achievement on completion assignments (practice/homework)</b> represents the proportion of questions completed by the student across all assignments in this Subunit that define achievement by a student completing the assignment (i.e. practice tests and homework assignments where students are granted multiple attempts per question).<br /></p>
        <p><b>Achievement on proficiency assignments (quizzes/tests)</b> represents the proportion of questions that a student got correct across all assignments in this Subunit that define achievement by proficiency (i.e. quizzes and tests where students are granted only one attempt per question).</p>
      </div>
    );

    return (
      <div className={style.qqReportContainer} ref={this.containerRef} >
        <div className={style.menuModules}>
          <div className={style.titleModule}>{activeSubunit.name}</div>
          <ReportBreadcrumbs
            items={breadcrumbItems}
            onTabChange={onTabChange}
            maxLength={70}
          />
          <div className={style.dropdownModules}>
            <Media query="(max-width: 709px)">
              <Menu
                className={style.menu}
                id="subunitd1"
                options={subunits}
                onChange={this.handleSubmoduleUpdate}
                selectedLabel={activeSubunit.name}
                hasLabel
                label="Subunit:"
                boxed
              />
            </Media>
          </div>
        </div>
        {subunitHighlights && subUnitHighlightsComponent(subunitHighlights)}
        {performanceByAssignment && (
          <PerformanceByAssignmentComponent
            data={performanceByAssignment}
            courseId={course.id}
            onTabChange={onTabChange}
            reportType={reportType}
            sendEvent={sendAnalyticsEvent}
          />
        )}

        {getConfigObject().FEATURE_USE_EXTERNAL_INSIGHTS &&
          <ExternalFrameworkCard
            rows={performanceByExternalFrameworks}
            reportType={reportType}
          />
        }

        {performanceByLearningObjective && performanceByLearningObjectiveComponent(performanceByLearningObjective, hasStudents, onTabChange, REPORT_TYPES.subunit)}
        <PerformanceByStudentComponent
          data={performanceByStudent}
          assignments={subunitHighlights.assignments}
          onTabChange={onTabChange}
          modalContent={modalContent}
          buildReportUrl={studentId => `reports/type/student-subunit/${studentId}/${activeSubunit ? activeSubunit.id : ''}`}
          reportType={reportType}
          sendEvent={sendAnalyticsEvent}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  loadSubunitReport: loadSubunitReportAction,
  updateSubunitReport: updateSubunitReportAction,
  sendAnalyticsEvent,
}, dispatch);

function mapStateToProps(state) {
  return {
    course: state.reports.courseAbstract,
    subunitReport: state.reports.subunitReport,
    subunits: state.reports.subunitList.subunits,
    unit: state.reports.subunitList.unit,
    activeSubunit: state.reports.subunitList.activeSubunit,
    loading: !state.reports.subunitList.subunits || state.reports.subunitList.loading
      || !state.reports.subunitReport || state.reports.subunitReport.loading,
    error: state.reports.subunitList.error,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QQReport);
